import React, { FC } from 'react';
import Navbar, { Brand } from 'react-bootstrap/lib/Navbar';

import { INCIDENT_TYPE } from '@silverfort-nodelibs/common/utils/consts';
import { getEnumEntryByValue } from '@silverfort-nodelibs/common/utils/common';

import riskIcon from '../../../components/Layout/Images/risk_icon.svg';

import IncidentOverview from './IncidentOverview';
import useIncidentStatusUpdate from '../api/mutations/useIncidentStatusUpdate';
import useGetIncidentById from '../api/queries/useGetIncidentById';
import { useGetUserData } from '../../../api';
import SearchEntity from '../../../components/Controls/SearchEntitiy';

interface Props {
    match: {
        params: {
            incidentID: string;
            incidentType: string;
        };
    };
}

const IncidentLayout: FC<Props> = ({ match }) => {
    const { incidentID, incidentType } = match.params;
    const incidentTypeObj = getEnumEntryByValue(INCIDENT_TYPE, Number(incidentType)) || {};
    const { userSession: userData, loading: isFetchingUser } = useGetUserData();
    const { data: incident, isFetching: isFetchingIncident, refetch: refetchIncident } = useGetIncidentById(incidentID);
    const { mutate: updateIncidentStatus } = useIncidentStatusUpdate({
        onSuccess: refetchIncident,
        returnIncidentDataWithSummary: true
    });

    const showLoader = isFetchingIncident || isFetchingUser;

    return (
        <div id="entityPage" className={'light-scrollbar'}>
            {showLoader && (
                <div className="silverfort-loader">
                    <div className="logo"></div>
                </div>
            )}
            <div className="bg-sf-dark-400 h-screen overflow-auto pl-[60px]">
                <Navbar fluid={true} style={{ maxWidth: '100%', minWidth: '100%' }}>
                    <Brand>
                        <div className="flex items-center">
                            <img src={riskIcon} alt="" />
                            <span>{`${incidentTypeObj?.guiName || 'Unknown'} Incident`}</span>
                        </div>
                        <SearchEntity user={userData?.user} />
                    </Brand>
                </Navbar>
                <IncidentOverview
                    incidentID={incidentID}
                    onStatusChange={updateIncidentStatus}
                    showLoader={showLoader}
                    incidentType={incidentTypeObj}
                    incidentData={incident}
                    userData={userData}
                    incidentSummary={incident?.summary}
                />
            </div>
        </div>
    );
};

export default IncidentLayout;
